import styled, { css } from 'styled-components';

interface Props {
  $isLoading?: boolean;
}

function isLoadingStyle({ $isLoading = false }: Props) {
  if ($isLoading) {
    return css`
      opacity: 0.5;
    `;
  }
}

export default styled.div<Props>`
  pointer-events: auto;
  display: flex;
  transition: 0.3s ease-in-out opacity;
  ${isLoadingStyle}
`;
